import { render } from "./NewRecipeComponent.vue?vue&type=template&id=f43a4cae&scoped=true"
import script from "./NewRecipeComponent.vue?vue&type=script&lang=js"
export * from "./NewRecipeComponent.vue?vue&type=script&lang=js"

import "./NewRecipeComponent.vue?vue&type=style&index=0&id=f43a4cae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f43a4cae"]])

export default __exports__